<div class="popup-screen">
  <div class="popup-container">
    <div class="popup-header">
      <span class="color-inherit">Stations</span>
      <button type="button" class="close" (click)="close.emit()">&times;</button>
    </div>
    <div class="popup-body">
      <div id="map" style="height: 70vh;"></div>
    </div>
    <div class="popup-footer">
      <button type="button" class="btn btn-light" (click)="close.emit()">Close</button>
    </div>
  </div>
</div>

